var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"middleBox"},[_c('div',{staticClass:"HeaderBox"},[_c('Header')],1),_c('div',{staticClass:"sideContent"},[_c(_vm.contentList[_vm.comname],{tag:"component",on:{"goChat":_vm.goChat}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }